module.exports = __webpack_public_path__ + "img/audio-pause.146eab6b.png";